import ApplicationsView from './ApplicationsView';
export default ApplicationsView;
